import { closePlacement, deferPlacement, movePlacement, recordContact, } from '@/entities/queue-placement';
export async function recordContactAction(placementId, note) {
    await recordContact(placementId, note);
}
export async function deferPlacementAction(placementId, note) {
    await deferPlacement(placementId, note);
}
export async function movePlacementAction(placementId, targetQueueId) {
    await movePlacement(placementId, targetQueueId);
}
export async function closePlacementAction(placementId, note) {
    await closePlacement(placementId, note);
}
